<template>
  <div id="content-container" v-if="item">
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="配件详情">
      </el-page-header>
      <el-descriptions title="" size="small">
        <el-descriptions-item label="名称">{{
          item.name
        }}</el-descriptions-item>
        <el-descriptions-item label="编号">{{
          item.code
        }}</el-descriptions-item>
        <el-descriptions-item label="型号">{{
          item.model_number
        }}</el-descriptions-item>
        <el-descriptions-item label="整机编号">
          <template v-if="item.status == 2">
            <ProductLink :product="item.product"></ProductLink>
          </template>
          <template v-else>-</template>
        </el-descriptions-item>
        <el-descriptions-item
          :label="param.label"
          v-for="param in item.custom_params"
          :key="param.key"
        >
          {{ param.value }}
        </el-descriptions-item>
        <el-descriptions-item label="期初使用时间">{{
          item.start_man_hour
        }}</el-descriptions-item>
        <el-descriptions-item label="使用次数">{{
          item.used_count
        }}</el-descriptions-item>
        <el-descriptions-item label="维修次数">{{
          item.repair_count
        }}</el-descriptions-item>
        <el-descriptions-item label="预测寿命">{{
          item.age
        }}</el-descriptions-item>
        <el-descriptions-item label="总工作时长">{{
          item.total_man_hour
        }}</el-descriptions-item>
        <el-descriptions-item label="组装基地">
          {{ item.install_base.name }}
        </el-descriptions-item>
        <el-descriptions-item label="发往基地" v-if="item.category == 1">
          {{ item.base.name }}
        </el-descriptions-item>
        <el-descriptions-item label="库存基地" v-if="item.category == 2">
          <div>
            {{ item.base.name }}
          </div>
          <div class="text-danger" v-if="item.receive_base_id">
            {{ `（待${item.receive_base.name}接收）` }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="发往钻井" v-if="item.category == 2">
          <div>
            {{ item.drill_well.well_number || '无' }}
          </div>
          <div class="text-danger" v-if="item.receive_well_id">
            {{ `（待${item.receive_well.well_number}接收）` }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <ItemStatus :status="item.status"></ItemStatus>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ item.remark }}
        </el-descriptions-item>
      </el-descriptions>

      <template
        v-if="
          item.category == 2 &&
          item.status == 1 &&
          $store.state.userInfo.base_id
        "
      >
        <el-button
          v-if="
            !item.receive_base_id &&
            !item.drill_well_id &&
            !item.receive_well_id &&
            item.base_id == $store.state.userInfo.base_id
          "
          type="primary"
          size="mini"
          plain
          v-permission="Auth.instrumentItemStockManage"
          @click="itemStockOut()"
          >出库{{
        }}</el-button>
        <el-popconfirm
          v-if="
            item.base_id == $store.state.userInfo.base_id &&
            ((item.receive_base_id && !item.receive_well_id) ||
              (item.receive_well_id &&
                item.receive_well_id == item.drill_well_id))
          "
          title="确认撤回该配件吗？"
          @confirm="itemStockRecall()"
        >
          <el-button
            size="mini"
            plain
            slot="reference"
            v-permission="Auth.instrumentItemStockManage"
            type="danger"
            class="mr-10"
            >撤回</el-button
          >
        </el-popconfirm>

        <el-button
          v-if="item.receive_base_id == $store.state.userInfo.base_id"
          v-permission="Auth.instrumentItemStockManage"
          plain
          size="mini"
          type="danger"
          class="mr-10"
          @click="itemStockReject()"
          >拒收</el-button
        >
        <el-popconfirm
          v-if="
            !item.base_id ||
            (item.receive_base_id == $store.state.userInfo.base_id &&
              item.drill_well_id == 0)
          "
          title="确认入库该配件吗？"
          @confirm="itemStockIn()"
        >
          <el-button
            size="mini"
            plain
            slot="reference"
            v-permission="Auth.instrumentItemStockManage"
            type="danger"
            class="mr-10"
            >确认入库</el-button
          >
        </el-popconfirm>
        <el-button
          size="mini"
          plain
          v-if="
            item.base_id == $store.state.userInfo.base_id &&
            !item.receive_base_id &&
            !item.receive_well_id &&
            !item.drill_well_id
          "
          type="primary"
          class="mr-10"
          v-permission="Auth.instrumentItemStockManage"
          @click="itemSendToWell()"
          >发往钻井</el-button
        >
        <el-popconfirm
          v-if="
            item.receive_base_id == $store.state.userInfo.base_id &&
            item.drill_well_id > 0
          "
          title="确认该配件已从钻井返回吗？"
          @confirm="itemReceiveConfirm()"
        >
          <el-button
            size="mini"
            plain
            slot="reference"
            v-permission="Auth.instrumentItemStockManage"
            type="danger"
            class="mr-10"
            >确认接收</el-button
          >
        </el-popconfirm>
      </template>

      <template v-if="item.status != 3">
        <el-button
          v-permission="
            item.category == 1 ? Auth.itemEdit : Auth.instrumentItemEdit
          "
          type="primary"
          size="mini"
          plain
          @click="editItem"
          >编辑</el-button
        >
        <el-button
          size="mini"
          type="primary"
          plain
          @click="addUsedRecord(5)"
          v-permission="
            item.category == 1
              ? Auth.itemAddUseRecord
              : Auth.instrumentItemAddUseRecord
          "
          >添加使用记录</el-button
        >
        <el-button
          size="mini"
          type="primary"
          plain
          @click="addUsedRecord(6)"
          v-permission="
            item.category == 1
              ? Auth.itemAddRepairRecord
              : Auth.instrumentItemAddRepairRecord
          "
          >添加维修记录</el-button
        >
        <el-button
          size="mini"
          type="primary"
          plain
          @click="addAttachment"
          v-permission="
            item.category == 1
              ? Auth.itemAddAttachment
              : Auth.instrumentItemAddAttachment
          "
          >上传附件</el-button
        >
      </template>
    </div>

    <div class="panel" style="position: relative">
      <div class="export-btn">
        <el-button
          type="primary"
          size="mini"
          plain
          v-if="activeTab == 'tab1'"
          v-permission="
            item.category == 1
              ? Auth.itemUseRecordExport
              : Auth.instrumentItemUseRecordExport
          "
          @click="handleExport()"
          :loading="downloading"
          >导出使用记录</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          v-if="activeTab == 'tab2'"
          v-permission="
            activeTab == 'tab1'
              ? Auth.itemRepairRecordExport
              : Auth.instrumentItemRepairRecordExport
          "
          @click="handleExport()"
          :loading="downloading"
          >导出维修记录</el-button
        >
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="使用记录" name="tab1">
          <ItemRecords
            :item="item"
            :category="5"
            v-if="item.id"
            ref="tab1"
          ></ItemRecords>
        </el-tab-pane>
        <el-tab-pane label="维修记录" name="tab2">
          <ItemRecords
            :item="item"
            :category="6"
            v-if="item.id && activeTab == 'tab2'"
            ref="tab2"
          ></ItemRecords>
        </el-tab-pane>
        <el-tab-pane label="附件列表" name="tab3">
          <AttachmentTable
            :item="item"
            v-if="item.id && activeTab == 'tab3'"
            ref="tab3"
          ></AttachmentTable>
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="tab4">
          <ItemRecords
            :item="item"
            v-if="item.id && activeTab == 'tab4'"
          ></ItemRecords>
        </el-tab-pane>
      </el-tabs>
    </div>

    <ItemFormer
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></ItemFormer>

    <RepairFormer
      :model="record"
      :show.sync="recordFormerVisible"
      @created="recordCreated"
    ></RepairFormer>

    <StockoutFormer
      :model="model"
      :show.sync="stockoutFormerVisible"
      @updated="updatedCallback"
    ></StockoutFormer>

    <WellFormer
      :model="model"
      :show.sync="wellFormerVisible"
      @updated="updatedCallback"
    ></WellFormer>

    <AttachmentFormer
      :model="model"
      :show.sync="attachmentFormerVisible"
      @created="attachmentCreated"
    ></AttachmentFormer>
  </div>
</template>

<script>
import {
  itemDetail,
  itemStockIn,
  itemReceiveComfirm,
  itemRecall,
  itemReject,
} from '@/service/getData'
import ItemFormer from './former'
import ItemRecords from './item_records'
import RepairFormer from './repair_former'

import StockoutFormer from './stockout_former'
import WellFormer from './well_former'
import AttachmentTable from './attachment.vue'
import AttachmentFormer from './attachment_former.vue'

export default {
  components: {
    ItemFormer,
    RepairFormer,
    ItemRecords,
    StockoutFormer,
    WellFormer,
    AttachmentTable,
    AttachmentFormer,
  },
  data() {
    return {
      item: null,
      activeTab: 'tab1',
      model: {},
      formerVisible: false,
      record: {},
      recordFormerVisible: false,
      stockoutFormerVisible: false,
      wellFormerVisible: false,
      downloading: false,
      attachmentFormerVisible: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await itemDetail(this.$route.params.id)
      if (res.status != 0) return
      this.item = res.data
    },
    editItem() {
      this.model = this.clone(this.item)
      this.model.custom_params = this.copyCustomParam(
        this.item.template.custom_params,
        this.item.custom_params,
      )
      this.formerVisible = true
    },

    itemStockOut() {
      this.model = {
        receive_base_id: '',
        id: this.item.id,
      }
      this.stockoutFormerVisible = true
    },
    async itemStockIn() {
      let res = await itemStockIn({ id: this.item.id })
      if (res.code == 0) {
        this.updatedCallback()
      }
    },
    itemSendToWell() {
      this.model = {
        base_id: this.item.base_id,
        receive_well_id: '',
        id: this.item.id,
      }
      this.wellFormerVisible = true
    },
    async itemReceiveConfirm() {
      let res = await itemReceiveComfirm({ id: this.item.id })
      if (res.code == 0) {
        this.updatedCallback()
      }
    },

    // 撤回
    async itemStockRecall() {
      let res = await itemRecall({
        id: this.item.id,
      })
      if (res.code == 0) {
        this.$notify.success('已撤回！')
        this.updatedCallback()
      }
    },

    //拒收
    itemStockReject() {
      this.$prompt('拒收原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(async ({ value }) => {
        let res = await itemReject({
          id: this.item.id,
          remark: value,
        })
        if (res.code == 0) {
          this.$notify.success('已拒收！')
          this.updatedCallback()
        }
      })
    },

    updatedCallback() {
      this.getData()
    },
    addUsedRecord(type) {
      this.record = {
        item_id: this.item.id,
        product_id: this.item.product.id,
        product_category: this.item.category,
        used_hour: 0,
        used_extra: [],
        category: type,
        used_date: '',
        usage: '',
        inspection: '',
        solution: '',
        imgs: [],
        videos: [],
        remark: '',
      }

      if (type == 6 && this.record.product_id == 0) {
        this.record.product_id = ''
      }

      if (type == 5) {
        this.record.used_extra = [
          { key: 'block', value: '', label: '使用区块' },
          { key: 'well_team_number', value: '', label: '井队号' },
          { key: 'well_number', value: '', label: '井号' },
        ]
      }
      this.recordFormerVisible = true
    },
    recordCreated(item) {
      this.item.id = 0
      this.getData()
      this.activeTab = item.category == 6 ? 'tab2' : 'tab1'
    },

    addAttachment() {
      this.activeTab = 'tab3'
      this.model = {
        item_id: this.item.id,
        tag: '',
        remark: '',
        attachments: [],
      }
      this.attachmentFormerVisible = true
    },

    attachmentCreated(item) {
      this.item.id = 0
      this.getData()
    },

    handleExport() {
      this.downloading = true
      this.$refs[this.activeTab].handleExport()
      this.downloading = false
    },
  },
}
</script>

<style>
.el-timeline-item {
  padding-bottom: 10px;
}

.export-btn {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
}
</style>